const normalizeKey = (value) => (value || '').toString().trim().toLowerCase();

// Keep these as transliterations (not semantic translations).
// If a language isn't listed, we fall back to the original English skill name.
const TRANSLITERATIONS_BY_LANG = {
  kn: {
    plumber: 'ಪ್ಲಂಬರ್',
    electrician: 'ಎಲೆಕ್ಟ್ರಿಷಿಯನ್',
    carpenter: 'ಕಾರ್ಪೆಂಟರ್',
    painter: 'ಪೇಂಟರ್',
    mason: 'ಮೇಸನ್',
    gardener: 'ಗಾರ್ಡನರ್',
    cleaning: 'ಕ್ಲೀನಿಂಗ್',
    driver: 'ಡ್ರೈವರ್',
    cook: 'ಕುಕ್',
    'security guard': 'ಸಿಕ್ಯೂರಿಟಿ ಗಾರ್ಡ್',
    'ac repair': 'ಏಸಿ ರಿಪೇರ್',
    'computer repair': 'ಕಂಪ್ಯೂಟರ್ ರಿಪೇರ್',
    'mobile repair': 'ಮೊಬೈಲ್ ರಿಪೇರ್',
    tailor: 'ಟೇಲರ್',
    mechanic: 'ಮೆಕಾನಿಕ್',
    welder: 'ವೆಲ್ಡರ್',
    helper: 'ಹೆಲ್ಪರ್',
    'delivery person': 'ಡೆಲಿವರಿ ಪರ್ಸನ್',
    // "Daily labour" is a meaning-translation (day-wage labour), not a transliteration.
    'daily labour': 'ದಿನಗೂಲಿ',
    'daily labor': 'ದಿನಗೂಲಿ',
    'daily labour & construction': 'ದಿನಗೂಲಿ ಮತ್ತು ನಿರ್ಮಾಣ',
  },
  ta: {
    plumber: 'பிளம்பர்',
    electrician: 'எலெக்ட்ரிஷியன்',
    carpenter: 'கார்பெண்டர்',
    painter: 'பேன்டர்',
    mason: 'மேசன்',
    gardener: 'கார்டனர்',
    cleaning: 'கிளீனிங்',
    driver: 'டிரைவர்',
    cook: 'குக்',
    'security guard': 'சிக்யூரிட்டி கார்ட்',
    'ac repair': 'ஏசி ரிபெயர்',
    'computer repair': 'கம்ப்யூட்டர் ரிபெயர்',
    'mobile repair': 'மொபைல் ரிபெயர்',
    tailor: 'டெய்லர்',
    mechanic: 'மெக்கானிக்',
    welder: 'வெல்டர்',
    helper: 'ஹெல்பர்',
    'delivery person': 'டெலிவரி பெர்சன்',
  },
  te: {
    plumber: 'ప్లంబర్',
    electrician: 'ఎలక్ట్రిషియన్',
    carpenter: 'కార్పెంటర్',
    painter: 'పెయింటర్',
    mason: 'మేసన్',
    gardener: 'గార్డెనర్',
    cleaning: 'క్లీనింగ్',
    driver: 'డ్రైవర్',
    cook: 'కుక్',
    'security guard': 'సెక్యూరిటీ గార్డ్',
    'ac repair': 'ఏసీ రిపేర్',
    'computer repair': 'కంప్యూటర్ రిపేర్',
    'mobile repair': 'మొబైల్ రిపేర్',
    tailor: 'టైలర్',
    mechanic: 'మెకానిక్',
    welder: 'వెల్డర్',
    helper: 'హెల్పర్',
    'delivery person': 'డెలివరీ పర్సన్',
  },
  ml: {
    plumber: 'പ്ലംബര്‍',
    electrician: 'ഇലക്ട്രിഷ്യന്‍',
    carpenter: 'കാര്‍പെന്റര്‍',
    painter: 'പെയിന്റര്‍',
    mason: 'മേസണ്‍',
    gardener: 'ഗാര്‍ഡനര്‍',
    cleaning: 'ക്ലീനിംഗ്',
    driver: 'ഡ്രൈവര്‍',
    cook: 'കുക്ക്',
    'security guard': 'സിക്യൂരിറ്റി ഗാര്‍ഡ്',
    'ac repair': 'എസി റിപെയര്‍',
    'computer repair': 'കമ്പ്യൂട്ടര്‍ റിപെയര്‍',
    'mobile repair': 'മൊബൈല്‍ റിപെയര്‍',
    tailor: 'ടെയിലര്‍',
    mechanic: 'മെക്കാനിക്',
    welder: 'വെല്‍ഡര്‍',
    helper: 'ഹെല്‍പര്‍',
    'delivery person': 'ഡെലിവറി പേഴ്സൺ',
  },
  hi: {
    plumber: 'प्लम्बर',
    electrician: 'इलेक्ट्रिशियन',
    carpenter: 'कारपेंटर',
    painter: 'पेंटर',
    mason: 'मेसन',
    gardener: 'गार्डनर',
    cleaning: 'क्लीनिंग',
    driver: 'ड्राइवर',
    cook: 'कुक',
    'security guard': 'सिक्योरिटी गार्ड',
    'ac repair': 'एसी रिपेयर',
    'computer repair': 'कंप्यूटर रिपेयर',
    'mobile repair': 'मोबाइल रिपेयर',
    tailor: 'टेलर',
    mechanic: 'मेकैनिक',
    welder: 'वेल्डर',
    helper: 'हेल्पर',
    'delivery person': 'डिलीवरी पर्सन',
  },
};

export function getSkillDisplayName(skillName, rawLangCode) {
  const name = (skillName || '').toString().trim();
  if (!name) return '';
  const lang = (rawLangCode || '').toString().trim().toLowerCase().split('-')[0];
  if (!lang || lang === 'en') return name;
  const map = TRANSLITERATIONS_BY_LANG[lang];
  if (!map) return name;
  const key = normalizeKey(name);
  return map[key] || name;
}


